export const shortBreakPeriods = [
	{ period: '1 day' },
	{ period: '2 days' },
	{ period: '3 days' },
	{ period: '4 days' },
	{ period: '5 days' },
	{ period: '6 days' },
	{ period: '7 days' },
	{ period: '8 days' },
	{ period: '9 days' },
	{ period: '10 days' },
	{ period: '11 days' },
	{ period: '12 days' },
	{ period: '13 days' },
	{ period: '14 days' },
	{ period: '15 days' },
	{ period: '16 days' },
	{ period: '17 days' },
	{ period: '18 days' },
	{ period: '19 days' },
	{ period: '20 days' },
	{ period: '21 days' },
	{ period: '22 days' },
	{ period: '23 days' },
	{ period: '24 days' },
	{ period: '25 days' },
	{ period: '26 days' },
	{ period: '27 days' },
	{ period: '28 days' },
	{ period: '29 days' },
	{ period: '30 days' },
	{ period: '31 days' },
	{ period: '1 week' },
	{ period: '2 weeks' },
	{ period: '3 weeks' },
	{ period: '4 weeks' },
	{ period: '5 weeks' },
	{ period: '6 weeks' },
	{ period: '7 weeks' },
];

export const longBreakPeriods = [{ period: '6 months' }];

export const usBreakPeriods = [
	{
		period: '3 Days',
	},
	{
		period: '7 Days',
	},
	{
		period: '30 Days',
	},
	{
		period: '6 Months',
	},
];
